import React from "react";
import config from "../../config/config";
import "../../css/orders.css";
import { Icon, Card } from "@shopify/polaris";
import CSVReader from "react-csv-reader";
import { PageDownMajor } from "@shopify/polaris-icons";
import { CSVLink } from "react-csv";
import { Row, Col, Progress } from "reactstrap";
import callApi from "../../utils/apiCaller";

import Swal from "sweetalert2";
export class UploadCSVWoo extends React.Component {
  state = {
    showLoadingPage: false,
    dataCSV: [{}],
    currentOrder: 0,
    totalOrder: 0,
    loadingValue: 0,
  };

  componentDidMount = () => {
    if (config.platform === "WOO_COMMERCE") {
      this.getListOrdersCSV();
    }
  };

  getListOrdersCSV = () => {
    let params = {
      action: "getListOrdersCSV",
    };
    callApi("get", params).then((res) => {
      this.setState({ dataCSV: res.data.listOrdersCSV });
    });
  };

  showLoadingPage = () => {
    this.setState({ showLoadingPage: true });
  };

  hideLoadingPage = () => {
    this.setState({ showLoadingPage: false });
  };

  handleFileCsvUpload = async (data) => {
    let count = data.length;
    var pages = Math.ceil(count / 100);
    this.setState({ totalOrder: count });
    this.showLoadingPage();
    for (var i = 0; i < pages; i++) {
      let listSave = data.slice(i * 100, i * 100 + 100);
      if (i === pages - 1) {
        await this.uploadOrderCSV(listSave, "last");
      } else {
        var loadingValue = Math.ceil((i / pages) * 100);
        this.setState({ loadingValue: loadingValue });
        await this.uploadOrderCSV(listSave, "process");
      }
    }
  };

  uploadOrderCSV = async (data, status) => {
    let formData = new FormData();
    formData.append("data", JSON.stringify(data));
    formData.append("shop", config.shop);
    formData.append("status", status);
    formData.append("action", "handleFileCsvUpload");
    callApi("post", formData).then((res) => {
      if (status === "last") {
        this.hideLoadingPage();
        if (res.data.state === 1) {
          this.props.updateListOrderWoo();
          Swal.fire({
            icon: "success",
            title: "Successfully",
            text: res.data.msg,
            showCloseButton: false,
            showConfirmButton: false,
            timer: 3000,
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: res.data.msg,
            showCancelButton: true,
            showConfirmButton: true,
          });
        }
      } else {
        let currentOrder = this.state.currentOrder + 100;
        this.setState({ currentOrder: currentOrder });
      }
    });
  };

  render() {
    const papaparseOptions = {
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
      transformHeader: (header) => header.toLowerCase().replace(/\W/g, "_"),
    };

    return (
      <Row style={{ marginTop: "30px" }}>
        <Col md={12}>
          <Card sectioned title="Update Tracking Info CSV">
            <div
              style={{
                position: "absolute",
                top: "4px",
                right: "20px",
              }}
            >
              <CSVLink
                data={this.state.dataCSV}
                filename={"listOrders_" + Date.now() + ".csv"}
                className="Polaris-Button Polaris-Button--primary"
              >
                <Icon source={PageDownMajor} />
                <span className="ml-2">Download List Orders</span>
              </CSVLink>
            </div>
            <div className="text-center">
              <CSVReader
                cssClass="react-csv-input"
                label="Download List Orders and update tracking information. Then upload the file"
                onFileLoaded={this.handleFileCsvUpload}
                parserOptions={papaparseOptions}
              />
            </div>
          </Card>
        </Col>
        {this.state.showLoadingPage ? (
          <div id="i_loading_page">
            <div
              className="loading_page_content"
              style={{ textAlign: "center" }}
            >
              <img
                src="https://linh.omegatheme.com/dev-better-search/admin/images/loading_cart.gif"
                alt="loading"
              />
              <p className="mb-4">
                {" "}
                Uploading order list:{" "}
                <b>
                  {this.state.currentOrder} / {this.state.totalOrder}
                </b>{" "}
                Orders
              </p>

              <Progress
                animated
                style={{
                  height: "20px",
                  margin: "auto",
                  width: "75%",
                }}
                color="info"
                value={this.state.loadingValue}
                max="100"
              ></Progress>
            </div>
          </div>
        ) : null}
      </Row>
    );
  }
}
